import React from 'react';
import PropTypes from 'prop-types';
import { Clock, AlertTriangle } from 'lucide-react';

/**
 * 時間切れ時の視覚的強化アラートコンポーネント
 * 既存の時間切れ表示を置き換える改善版
 */
const TimeUpAlert = ({ 
  answerRevealMode = 'immediate',
  currentQuestionIndex = 0,
  totalQuestions = 1,
  freeNavigation = false,
  className = ''
}) => {
  // 時間切れ後の動作メッセージを生成
  const getTimeUpMessage = () => {
    if (freeNavigation) {
      return 'コンテンツ全体の制限時間が終了しました。回答を確認して結果を表示してください。';
    }
    
    if (answerRevealMode === 'end') {
      if (currentQuestionIndex === totalQuestions - 1) {
        return '結果を処理中です...';
      }
      return '自動的に次の問題に進みます...';
    }
    
    return '「次の問題へ」ボタンをクリックして次に進んでください。';
  };

  // アニメーション設定（段階的）
  const getAnimationClasses = () => {
    if (freeNavigation) {
      // 自由移動モード：より強いアニメーション（全体時間切れ）
      return 'animate-pulse';
    }
    // 一方向移動モード：控えめなアニメーション
    return 'animate-bounce';
  };

  return (
    <div className={`
      bg-gradient-to-r from-red-50 to-red-100 
      border-2 border-red-200 
      text-red-800 
      p-4 rounded-lg mb-4 
      shadow-lg
      ${className}
    `}>
      <div className="flex items-start gap-3">
        {/* アイコン部分 */}
        <div className={`flex-shrink-0 ${getAnimationClasses()}`}>
          <div className="bg-red-200 rounded-full p-2">
            <Clock size={24} className="text-red-600" />
          </div>
        </div>
        
        {/* メッセージ部分 */}
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <AlertTriangle size={20} className="text-red-600" />
            <h3 className="font-bold text-lg">⏰ 時間切れ</h3>
          </div>
          
          <p className="text-sm text-red-700 leading-relaxed">
            {getTimeUpMessage()}
          </p>
          
          {/* 追加情報（自由移動モードの場合） */}
          {freeNavigation && (
            <div className="mt-3 p-2 bg-red-200 rounded text-xs text-red-800">
              💡 ヒント: まだ回答していない問題がある場合は、回答してから結果を確認してください。
            </div>
          )}
        </div>
      </div>
      
      {/* プログレスインジケーター（一方向移動モードで自動進行の場合） */}
      {!freeNavigation && answerRevealMode === 'end' && currentQuestionIndex < totalQuestions - 1 && (
        <div className="mt-3 pt-3 border-t border-red-200">
          <div className="flex items-center gap-2 text-xs text-red-600">
            <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-red-600"></div>
            <span>次の問題に進んでいます...</span>
          </div>
        </div>
      )}
    </div>
  );
};

TimeUpAlert.propTypes = {
  answerRevealMode: PropTypes.string,
  currentQuestionIndex: PropTypes.number,
  totalQuestions: PropTypes.number,
  freeNavigation: PropTypes.bool,
  className: PropTypes.string,
};

export default TimeUpAlert; 